import { render, staticRenderFns } from "./MovableImageObjectMenu.vue?vue&type=template&id=1bbe0f5a&scoped=true&"
import script from "./MovableImageObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./MovableImageObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MovableImageObjectMenu.vue?vue&type=style&index=0&id=1bbe0f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe0f5a",
  null
  
)

export default component.exports